import * as React from 'react';

// razão social; se não houver, nome fantasia; se não houver, o responsável
export function nomeFornecedor(fornecedor) {
  if (!fornecedor) return '-';
  const { razao_social, nome_fantasia, nome } = fornecedor;
  return [razao_social, nome_fantasia, nome].find((n) => n && n.trim()) || '-';
}

const FornecedorField = ({ record }) => <span>{nomeFornecedor(record)}</span>;

export default FornecedorField;
